import { render, staticRenderFns } from "./LoginFormVersion.vue?vue&type=template&id=003d7708&"
import script from "./LoginFormVersion.vue?vue&type=script&lang=js&"
export * from "./LoginFormVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports